var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.sale_modifications_count > 0)?_c('b-button',{staticClass:"m-l-10",attrs:{"size":"sm","variant":"outline-primary"},on:{"click":function($event){$event.stopPropagation();return _vm.show.apply(null, arguments)}}},[_vm._v(" Mod ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }